import SpaceScene from "../../../../../content/404/components/SpaceScene";
import * as React from 'react';
export default {
  SpaceScene,
  React
};